import { __decorate } from "tslib";
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedHttp } from '../../../../services/http-client.service';
import { UtilityService } from '../../../../services/utility.service';
import { WebClientService } from '../../../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CountdownTimerComponent } from './../../../countdown-timer';
/**
 * Confirm Component
 */
let ConfirmSellComponent = class ConfirmSellComponent {
    constructor(httpClient, route, convertor, webSettingsService, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.route = route;
        this.convertor = convertor;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.confirmData = {};
        this.orderId = 0;
        this.userData = {};
        this.status = 'registred_user';
        this.textColor = '';
        this.backColor = '';
        this.successColor = '';
        this.accentColor = '';
        this.orderType = 'sell';
        this.paymentCanExpire = false;
        this.isPaymentExpirationTerminal = false;
        this.mainColor = '';
        this.userData = JSON.parse(localStorage.getItem('user'));
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
        });
        this.userType = this.userData.user_type_id.type;
        this.status = this.userType + '_user';
        this.isUser = false;
        this.isIndividual = this.userData.is_company_user ? 0 : 1;
    }
    ngOnInit() {
        this.sub = this.route.params.subscribe((params) => {
            this.orderId = params['orderId'];
            this.getOrderData(this.orderId + '');
        });
    }
    ngAfterViewInit() {
    }
    getOrderData(oid) {
        if (oid !== '') {
            this.httpClient.get('market/user/orders/' + oid).subscribe((data) => {
                this.confirmData = data;
                if (!('bank_payment_details' in this.confirmData)) {
                    this.confirmData.bank_payment_details = null;
                }
                this.meanOfPayment = this.confirmData.mean_of_payment.verbose_id;
                this.nameOfCurrency = this.confirmData.cryptocurrency;
                this.convertor.convertToShortcut(this.nameOfCurrency).then(data => {
                    this.currency = data;
                    this.httpClient.get('market/feesandlimits?ecurrency=' + this.currency + '&mop=' + this.meanOfPayment + '&user_type=' + this.userType + '&order_type=sell' + '&is_individual=' + this.isIndividual + '&chain=' + this.confirmData.ecurrency_chain['chain']['name']).subscribe((data) => {
                        this.provision = parseFloat(data['sell'][this.currency][this.meanOfPayment][this.userType].fee);
                    });
                });
            });
        }
    }
    confirmedCardTransaction(isCard) {
    }
};
ConfirmSellComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: UtilityService },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
__decorate([
    ViewChild(CountdownTimerComponent, { static: true })
], ConfirmSellComponent.prototype, "timer", void 0);
ConfirmSellComponent = __decorate([
    Component({
        selector: 'ecd-confirm',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./confirm.component.html")).default
    })
], ConfirmSellComponent);
export { ConfirmSellComponent };
